import { Controller, Get } from '@nestjs/common';
import { ApiExcludeController } from '@nestjs/swagger';
import { AuthNPaasService } from '../services/authnpaas.service';

@ApiExcludeController()
@Controller('api/authnpaas')
export class AuthNPaasController {
  constructor(private readonly authnService: AuthNPaasService) {}

  /**
   * 获取当前登录用户的飞书 user_id
   *
   * GET /api/authnpaas/lark-user-id
   */
  @Get('lark-user-id')
  async getCurrentUserLarkUserId() {
    const larkUserId = await this.authnService.getCurrentUserLarkUserId();
    return { lark_user_id: larkUserId };
  }
}
